import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'ADMIN',
    entityName: 'SYSTEM_CERTIFICATE',
});

const initialState = {
    ...crudInitialState,
    deletedSystemCertificate: {},
    deleting: false,
    saving: false,
    progress: null,
    snackBar: false,
    snackStart: false
};

const reducer = (state = initialState, action) => {
    const newState = crudReducer(state, action);
    if (newState !== null) {
        return newState;
    }
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
            case 'SYSTEM_CERTIFICATE|PROGRESS':
            return { ...state, progress: action.progress, maxSize: action.maxSize, loadSize: action.loadSize, snackStart: action.snackStart };
        default:
            return state;
    }
};
export default reducer;
